import React, { Component } from 'react';
import { connect } from 'react-redux';

import store from './store';
import { showNormalNotification } from '../redux/actions/notificationsActions';
import { simpleId } from '../libs/utils';

const notification = params => store.dispatch(showNormalNotification({ ...params }));

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    const trackingCode = simpleId();
    this.setState({
      error        : error,
      errorInfo    : errorInfo,
      trackingCode : trackingCode
    });
    error.trackingCode = trackingCode;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.error) {
      const { trackingCode } = nextState.error;
      setTimeout(() => {
        notification({
          color    : 'danger',
          message  : `Ocurrió un error, si el problema persiste, limpia el cache de tu navegador e intente de nuevo o más tarde. Se ha realizdo un reporte automático con el código: ${trackingCode}`,
          duration : 10,
          unique   : true
        });
      }, 0);
      setTimeout(() => {
        notification({
          color    : 'danger',
          message  : `Ocurrió un error, si el problema persiste, limpia el cache de tu navegador e intente de nuevo o más tarde. Se ha realizdo un reporte automático con el código: ${trackingCode}`,
          duration : 10,
          unique   : true
        });
      }, 2500);
    }
    return true;
  }

  render() {
    return this.props.children;
  }
}

export default connect(state => ({
  appUser: state.account,
}), null)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/app/ErrorBoundary.js